import React from 'react';

const members = [
  {
    id: 1,
    name: 'V S Tomy',
    role: 'President',
    image: 'images/vstommy.jpeg',
  },
  {
    id: 2,
    name: 'Jose Palakkuzhy',
    role: 'Vice President',
    image: 'images/Josepalakkuzhy.jpeg',
  },
  {
    id: 3,
    name: 'K J Manoj Kumar',
    role: 'Secretary',
    image: 'images/Kjmanojkumar.jpeg',
  },
  
  {
    id: 4,
    name: 'Mathai M J (Sunny M J)',
    role: 'Joint Secretary',
    image: 'images/Mathaimj.jpeg',
  },
  {
    id: 5,
    name: 'Shinoj P C',
    role: 'Treasurer',
    image: 'images/shinojpc.jpeg',
  },
  {
    id: 6,
    name: 'Babu Mathew',
    image: 'images/babumathew.jpeg',
  },
  {
    id: 7,
    name: 'George M A',
    image: 'images/georgema.jpeg',

  },
  {
    id: 8,
    name: 'Sajimon K V',
    image: 'images/Sajimonkv.jpeg',
  },
{
    id: 9,
    name: 'Jomon James',
    image: 'images/joemonjames.jpeg',
},
{
    id: 10,
    name: 'Saji Augustin',
    image: 'images/sajiaugustin.jpeg',
},
{
    id: 11,
    name: 'Shibu George',
    image: 'images/shibugeorge.jpeg',
},
{
    id: 12,
    name: 'Anand T George',
    image: 'images/anandtgeorge.jpeg',
},
{
    id: 13,
    name: 'Nitheesh Scaria',
    image: 'images/nidheeshscaria.jpeg',
},
{
    id: 14,
    name: 'George C J',
    image: 'images/georgecj.jpeg',
},
{
    id: 15,
    name: 'Benny Augustin',
    image: 'images/bennyaugustin.jpeg',
},
{
    id: 16,
    name: 'Jobin Cheriyan',
    image: 'images/jobincheriyan.jpeg',
},
{
    id: 17,
    name: 'Abhilash K J',
    image: 'images/abhilashkj.jpeg',
},
{
    id: 18,
    name: 'Joseph Mathew',
    image: 'images/josephmathew.jpeg',
},
{
    id: 19,
    name: 'Binoy Thomas',
    image: 'images/vinoythomas.jpeg',
},
{
    id: 20,
    name: 'Binu C Mathew',
    image: 'images/binucmathew.jpeg',
},
];

const Members = () => {
  return (
    <section className="bg-white py-32">
      <div className="px-8">

        {/* Header */}
        <div className="text-center mb-24 space-y-6">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900">
            Our Members
          </h2>
          <p className="text-xl text-blue-800 max-w-4xl mx-auto leading-relaxed">
            Dedicated individuals who contribute their time, skills, and passion
            to serve the community.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-12 gap-y-16">
          {members.map((member) => (
            <div key={member.name} className="text-center">
              {/* Image */}
              <img
                src={member.image}
                alt={member.name}
                loading="lazy"
                decoding="async"
                className="mx-auto h-28 w-28 rounded-full object-cover"
              />

              {/* Name */}
              <h3 className="mt-6 text-base font-semibold text-gray-900">
                {member.name}
              </h3>

              {/* Role */}
              <p className="mt-1 text-sm text-gray-500">
                {member.role}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Members;
